import MatchedMap from 'utilities/src/matchedMap';

import { InputThemeEnum, type InputThemeProps } from '../../../utils/themes';
import { InputSizeEnum } from '../../../utils/size';

/**
 * LabelTop Common Classes
 */

const labelTopSizeClassesMap = new MatchedMap([
  [InputSizeEnum.Small, 'site-paragraph-s'],
  [InputSizeEnum.Medium, 'site-paragraph-m'],
  [InputSizeEnum.Large, 'site-paragraph-m'],
]);

const labelTopClasses = '';

const labelTopOptionalClasses = 'site-paragraph-xs';

/**
 * LabelTop Theme Classes
 */

const labelTopBgThemeClassesMap = new MatchedMap([
  [InputThemeEnum.Dark, 'text-site-neutrals-100'],
  [InputThemeEnum.Light, 'text-site-neutrals-600'],
]);

/**
 * Site Theme
 */

const inputLabelTopSiteTheme = ({ inputTheme, inputSize }: Pick<InputThemeProps, 'inputTheme' | 'inputSize'>) => ({
  labelTopThemeClasses: labelTopClasses,
  labelTopOptionalThemeClasses: labelTopOptionalClasses,
  labelTopColorThemeClasses: labelTopBgThemeClassesMap.get(InputThemeEnum[inputTheme]),
  labelTopSizeClasses: labelTopSizeClassesMap.get(InputSizeEnum[inputSize]),
});

export default inputLabelTopSiteTheme;
